<tam-dialog class="append-entity-confirm-dialog-container" tid="append-entity-confirm-dialog" [opened]="dialogOpened">
    <ng-template #title>
        <span class="dialog-title">{{'note.append_entities_failed_items' | stringLiterals}}</span>
        <smart-icon class="dark dialog-close" name="close" (click)="clickCancel()">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="failed-note-list">
            <div class="note-list-header note-list-bac">
                <label class="entry-id">{{'note.id' | stringLiterals}}</label>
                <div class="border-line"></div>
                <label class="entry-subject">{{'note.subject' | stringLiterals}}</label>
                <div class="border-line"></div>
                <label class="entry-reason">{{'note.reason' | stringLiterals}}</label>
            </div>
            <div class="note-info">
                <div kendoTooltip class="note-list-header note-list-content"
                    *ngFor="let item of appendEntityFailedNotes;let i = index;">
                    <label class="entry-id" title="{{item.id}}">{{item.id}}</label>
                    <label class="entry-subject" title="{{item.subject}}">{{item.subject}}</label>
                    <label class="entry-reason" title="{{item.reason}}">{{item.reason}}</label>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button class="footer-button send-button" tam-button [tamType]="'primary'" [tamSize]="'normal'"
            (click)="clickCancel()">{{'general.ok' |
            stringLiterals}}</button>
    </ng-template>
</tam-dialog>